{
  "it": {
    "locale_field": {
      "fallback_tooltip": "Se per questa lingua non viene inserito alcun testo, questo testo predefinito verrà utilizzato come alternativa.",
      "fill_missing": "Compila la lingua mancante ({count}) | Compila le lingue mancanti ({count})",
      "fill_missing_budget_used": "Il budget AI di questo mese è esaurito.",
      "fill_missing_done": "Lingue mancanti compilate. Controlli il testo prima di salvare.",
      "fill_missing_errors": {
        "budget_reached": "Il budget AI di questo mese è esaurito. Contatti Ziggu per aumentarlo.",
        "generic": "Non è stato possibile compilare le lingue. Riprovi.",
        "too_long": "Questo testo è troppo lungo per tradurlo in una volta."
      },
      "fill_missing_tooltip": "Traduce da {language} con l'AI. Controlli il testo prima di salvare.",
      "translated_in": "Tradotto in"
    }
  }
}
